import { createStore, combineReducers } from 'redux';

import { authReducer } from '../components/Auth/authSlice';
import internalReducers from './reducers';

export default (otherReducers = {}, initialState) => {
	const combinedReducers = combineReducers({
		...internalReducers,
		...otherReducers,
		auth: authReducer,
	});

	return createStore(combinedReducers, initialState);
};
